import TransitionalCarePerformancePreview from './TransitionalCarePerformancePreview.model';
import TransitionalCareCompletedSummary from './TransitionalCareCompletedSummary.model';
import ProviderFollowUpAverage from './ProviderFollowUpAverage.model';

export interface ITransitionalCarePerformanceSummary {
    All: TransitionalCarePerformancePreview[] | null;
    Completed: TransitionalCarePerformancePreview[] | null;
    SeenFirstWindow: TransitionalCarePerformancePreview[] | null;
    SeenSecondWindow: TransitionalCarePerformancePreview[] | null;
    SeenThirdWindow: TransitionalCarePerformancePreview[] | null;
    SeenFourthWindow: TransitionalCarePerformancePreview[] | null;
    CompletedSummary: TransitionalCareCompletedSummary[] | null;
    Incomplete: TransitionalCarePerformancePreview[] | null;
    NotSeenFirstWindow: TransitionalCarePerformancePreview[] | null;
    NotSeenSecondWindow: TransitionalCarePerformancePreview[] | null;
    NotSeenThirdWindow: TransitionalCarePerformancePreview[] | null;
    NotSeenFourthWindow: TransitionalCarePerformancePreview[] | null;
    IncompleteSummary: TransitionalCareCompletedSummary[] | null;
    ReadmittedWithin30Days: TransitionalCarePerformancePreview[] | null;
    ProviderFollowUpAverages: ProviderFollowUpAverage[] | null;
    OverallAverageFollowUpDays: number | null;
}

export default class TransitionalCarePerformanceSummary implements ITransitionalCarePerformanceSummary {
    All: TransitionalCarePerformancePreview[] | null;
    Completed: TransitionalCarePerformancePreview[] | null;
    SeenFirstWindow: TransitionalCarePerformancePreview[] | null;
    SeenSecondWindow: TransitionalCarePerformancePreview[] | null;
    SeenThirdWindow: TransitionalCarePerformancePreview[] | null;
    SeenFourthWindow: TransitionalCarePerformancePreview[] | null;
    CompletedSummary: TransitionalCareCompletedSummary[] | null;
    Incomplete: TransitionalCarePerformancePreview[] | null;
    NotSeenFirstWindow: TransitionalCarePerformancePreview[] | null;
    NotSeenSecondWindow: TransitionalCarePerformancePreview[] | null;
    NotSeenThirdWindow: TransitionalCarePerformancePreview[] | null;
    NotSeenFourthWindow: TransitionalCarePerformancePreview[] | null;
    IncompleteSummary: TransitionalCareCompletedSummary[] | null;
    ReadmittedWithin30Days: TransitionalCarePerformancePreview[] | null;
    ProviderFollowUpAverages: ProviderFollowUpAverage[] | null;
    OverallAverageFollowUpDays: number | null;

    constructor() {
        this.All = null;
        this.Completed = null;
        this.SeenFirstWindow = null;
        this.SeenSecondWindow = null;
        this.SeenThirdWindow = null;
        this.SeenFourthWindow = null;
        this.CompletedSummary = null;
        this.Incomplete = null;
        this.NotSeenFirstWindow = null;
        this.NotSeenSecondWindow = null;
        this.NotSeenThirdWindow = null;
        this.NotSeenFourthWindow = null;
        this.IncompleteSummary = null;
        this.ReadmittedWithin30Days = null;
        this.ProviderFollowUpAverages = null;
        this.OverallAverageFollowUpDays = null;
    }
}